import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { StoreDetails } from "./StoreDetails";

const StoreManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <StoreDetails />} />
  </Switch>
);

export const StoreManagement = withRouter(StoreManagementRoutes);
